// authSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  user: {
    role: '',
    id: '',
    class: '',
    email: '',
    name: ''
  },
  token: null,
  status: 'idle',
  error: null,
  feeStatus: null
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCredentials: (state, action) => {
      state.user = action.payload.user;
      state.token = action.payload.token;
    },
    setAuthState: (state, action) => {
      return { ...state, ...action.payload };
    },
    logout: (state) => {
      state.user = { role: '', id: '', class: '', email: '', name: '' };
      state.token = null;
      state.feeStatus = null;
    },
    setFeeStatus: (state, action) => {
      state.feeStatus = action.payload;
    }
  }
});

export const { setCredentials, setAuthState, logout, setFeeStatus } = authSlice.actions;
export default authSlice.reducer;